module.exports = __webpack_public_path__ + "block-1-2x-0cd4a5bac45a2a3df80b1c90096df62b.webp";